export default __webpack_public_path__ + "static/media/027-love.bf860184.png";